const billingAddress = {
  heading: 'Rechnungsadresse',
  desc: '(Packstation nicht möglich)',
  mandatoryField: '* Diese Felder sind Pflichtfelder',
  checkDeliveryAddress: 'Abweichende <strong>Lieferaddresse</strong>',
  title: {
    label: 'Anrede*',
    optionsTitle: [
      { value: '', text: '-- Bitte wählen --', disabled: true },
      { value: 'Herr', text: 'Herr' },
      { value: 'Frau', text: 'Frau' },
      { value: 'Divers', text: 'Divers' }
    ],
    inputInvID: 'input-billing-title',
    inputInvFeedback: 'Bitte Anrede auswählen'
  },
  company: {
    title: 'Firma',
    label: 'Firma*',
    labelFor: 'kub-billingAddress-company',
    inputInvID: 'input-billing-company',
    inputInvFeedbackEmpty: 'Bitte Firma eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 100 Zeichen'
  },
  firstName: {
    label: 'Vorname*',
    labelFor: 'kub-billingAddress-firstName',
    inputInvID: 'input-billing-firstName',
    inputInvFeedbackEmpty: 'Bitte Vorname eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 30 Zeichen'
  },
  lastName: {
    label: 'Nachname*',
    labelFor: 'kub-billingAddress-lastName',
    inputInvID: 'input-billing-lastName',
    inputInvFeedbackEmpty: 'Bitte Nachname eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 30 Zeichen'
  },
  street: {
    label: 'Straße*',
    labelFor: 'kub-billingAddress-street',
    inputInvID: 'input-billing-street',
    inputInvFeedbackEmpty: 'Bitte Straße eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 60 Zeichen'
  },
  number: {
    label: 'Nr.*',
    labelFor: 'kub-billingAddress-number',
    inputInvID: 'input-billing-number',
    inputInvFeedbackEmpty: 'Bitte Hausnummer eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 10 Zeichen'
  },
  zip: {
    label: 'PLZ*',
    labelFor: 'kub-billingAddress-zip',
    inputInvID: 'input-billing-zip',
    inputInvFeedbackEmpty: 'Bitte Postleitzahl eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMinLength: 'Bitte Postleitzahl überprüfen',
    inputInvFeedbackMaxLength: 'Bitte Postleitzahl überprüfen'
  },
  city: {
    label: 'Ort*',
    labelFor: 'kub-billingAddress-city',
    inputInvID: 'input-billing-city',
    inputInvFeedbackEmpty: 'Bitte Ort eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 60 Zeichen'
  },
  country: {
    label: 'Land*',
    optionsCountry: [
      { value: { name: 'Deutschland', code: 'DE' }, text: 'Deutschland' },
      { value: { name: 'Österreich', code: 'AT' }, text: 'Österreich' }
    ],
    inputInvID: 'input-billing-country',
    inputInvFeedback: 'Bitte Land auswählen'
  },
  salesTax: {
    label: 'USt-IdNr',
    labelFor: 'kub-billingAddress-salesTax',
    inputInvID: 'input-billing-salesTax',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 20 Zeichen'
  },
  phone: {
    label: 'Telefon',
    labelFor: 'kub-billingAddress-phone',
    placeholder: 'nur für Rückfragen / Zustellung',
    inputInvID: 'input-billing-phone',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 20 Zeichen'
  },
  addition: {
    label: 'Adresszusatz',
    labelFor: 'kub-billingAddress-addition',
    inputInvID: 'input-billing-addition',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 60 Zeichen'
  },
  mail: {
    title: 'E-Mail',
    label: 'E-Mail*',
    labelFor: 'kub-billingAddress-mail',
    inputInvID: 'input-billing-mail',
    inputInvFeedbackEmpty: 'Bitte E-Mail-Adresse eintragen',
    inputInvFeedbackSpecialSign: 'Bitte eine gültige E-Mail-Adresse eingeben'
  }
}

const deliveryAddress = {
  heading: 'Lieferadresse',
  desc: '(Packstation nicht möglich)',
  title: {
    label: 'Anrede*',
    optionsTitle: [
      { value: '', text: '-- Bitte wählen --', disabled: true },
      { value: 'Herr', text: 'Herr' },
      { value: 'Frau', text: 'Frau' },
      { value: 'Divers', text: 'Divers' }
    ],
    inputInvID: 'input-delivery-title',
    inputInvFeedback: 'Bitte Anrede auswählen'
  },
  company: {
    label: 'Firma',
    labelFor: 'kub-deliveryAddress-company',
    inputInvID: 'input-delivery-company',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 100 Zeichen'
  },
  firstName: {
    label: 'Vorname*',
    labelFor: 'kub-deliveryAddress-firstName',
    inputInvID: 'input-delivery-firstName',
    inputInvFeedbackEmpty: 'Bitte Vorname eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 30 Zeichen'
  },
  lastName: {
    label: 'Nachname*',
    labelFor: 'kub-deliveryAddress-lastName',
    inputInvID: 'input-delivery-lastName',
    inputInvFeedbackEmpty: 'Bitte Nachname eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 30 Zeichen'
  },
  street: {
    label: 'Straße*',
    labelFor: 'kub-deliveryAddress-street',
    inputInvID: 'input-delivery-street',
    inputInvFeedbackEmpty: 'Bitte Straße eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 60 Zeichen'
  },
  number: {
    label: 'Nr.*',
    labelFor: 'kub-deliveryAddress-number',
    inputInvID: 'input-delivery-number',
    inputInvFeedbackEmpty: 'Bitte Hausnummer eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 10 Zeichen'
  },
  zip: {
    label: 'PLZ*',
    labelFor: 'kub-deliveryAddress-zip',
    inputInvID: 'input-delivery-zip',
    inputInvFeedbackEmpty: 'Bitte Postleitzahl eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMinLength: 'Bitte Postleitzahl überprüfen',
    inputInvFeedbackMaxLength: 'Bitte Postleitzahl überprüfen'
  },
  city: {
    label: 'Ort*',
    labelFor: 'kub-deliveryAddress-city',
    inputInvID: 'input-delivery-city',
    inputInvFeedbackEmpty: 'Bitte Ort eintragen',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 60 Zeichen'
  },
  country: {
    label: 'Land*',
    optionsCountry: [
      { value: { name: 'Deutschland', code: 'DE' }, text: 'Deutschland' },
      { value: { name: 'Österreich', code: 'AT' }, text: 'Österreich' }
    ],
    inputInvID: 'input-delivery-country',
    inputInvFeedback: 'Bitte Land auswählen'
  },
  phone: {
    label: 'Telefon',
    labelFor: 'kub-deliveryAddress-phone',
    placeholder: 'nur für Rückfragen / Zustellung',
    inputInvID: 'input-delivery-phone',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 20 Zeichen'
  },
  addition: {
    label: 'Adresszusatz',
    labelFor: 'kub-deliveryAddress-addition',
    inputInvID: 'input-delivery-addition',
    inputInvFeedbackSpecialSign: 'Bitte nur gültige Zeichen eingeben',
    inputInvFeedbackMaxLength: 'Maximal 60 Zeichen'
  }
}

export default {
  billingAddress,
  deliveryAddress
}
